
seedWebApp.controller('UserRolesController', ['$scope', 'UserRoleService', 'ToastService', '$uibModal', function ($scope, UserRoleService, ToastService, $uibModal) {

    $scope.prefs = {
        name: 'UserRolesGrid',
        selContact: null,
        sortByCol: null,
        canAdd: false,
        canEdit: true,
        canDelete: true,
    };

    $scope.customClass = function (item) {
        if (item == 'NORMAL')
            return 'set-label normal-user';
        else if (item == 'AGENT')
            return 'set-label agent-user';
    }

    $scope.columns = [
        { name: 'UserRoleID', display: 'ID', orderBy: 'asc', filterOptions: [], editable: false, width: 10, isKey: true },
        { name: 'UserRoleName', display: $scope.translation.Name, filterOptions: [], editable: true, width: 40 },
        { name: 'UserType', display: $scope.translation.UserType, customClass: $scope.customClass, filterOptions: [], editable: true, width: 25 },
        { name: 'UserCount', display: $scope.translation.UserCount, filterOptions: [], editable: true, width: 15 }
    ];

    $scope.prefs.customEdit = function (role) {

        if (!role) {
            role = {UserRoleID: 'ADD_NEW'};
        }

        var modalInstance = $uibModal.open({
            templateUrl: '/SPA/Settings/Users/EditPermissions.html' + seedWebApp.buildVersion,
            controller: 'EditPermissionsController',
            size: 'lg',
            resolve: {
                role: function () {
                    return role;
                }
            }
        });
        modalInstance.result.then(function (data) {
            var toastID = ToastService.createToast($scope.translation.SavingLoad, '', 0, 'wait');
            UserRoleService.save(data, function () {
                ToastService.removeToast(toastID);
                ToastService.createToast($scope.translation.ActionSuccessfullySaved, '', 4000, 'success');
                $scope.error = false;
                $scope.doRefresh();
            }, function errorFunc(errorDescription) {
                ToastService.removeToast(toastID);
                ToastService.createToast($scope.translation.ErrorSaving, '', 4000, 'error');
                $scope.error = false;
                $scope.doRefresh();
            });
        });
    };

    $scope.prefs.removeItem = function (item) {
        var toastID = ToastService.createToast($scope.translation.SavingLoad, '', 0, 'wait');
        UserRoleService.delete({ id: item.UserRoleID }, function () {
            $scope.error = false;
            ToastService.removeToast(toastID);
            $scope.doRefresh();
            ToastService.createToast('', 'Deletado com sucesso', 5000, 'success');
        }, function (errorDescription) {
            $scope.error = true;
            ToastService.removeToast(toastID);
            ToastService.createToast('Erro ao deletar', '', 8000, 'error');
            $scope.errorDescription = errorDescription.data.Message;
        });
    };

    $scope.loadItems = function () {
        $scope.loading = true;
        UserRoleService.getUserRoles().then(function (response) {
            if (response.data) {
                $scope.items = response.data;
                $scope.loading = false;
            }
        });
    };

    $scope.loadItems();

    $scope.doRefresh = function () {
        UserRoleService.resetCache();
        $scope.loadItems();
    };

    $scope.doInsert = function () {
        $scope.$broadcast('addItem');
    };

    //$(document).ready(function () {
    //    $scope.overflowSize = $scope.AdjustSize();
    //});

}]);
